import doRequest from "./apiRequestor";

export const fetchAllSnowflakeDataSources = async (idToken, setDataSources, setLoading, setErrorMessage) => {
    if (setLoading) setLoading(true);

    const response = await doRequest('/api/SnowflakeDataSources', idToken);

    if (!response.isError) {
        if (setDataSources) setDataSources(response.data);
        if (setLoading) setLoading(false);
        return response.data;
    } else {
        if (setErrorMessage) setErrorMessage(response.data);
        if (setLoading) setLoading(false);
        return null;
    }
};

export const fetchSnowflakeDataSourceById = async (idToken, dataSourceId, setDataSource, setLoading, setErrorMessage) => {
    if (setLoading) setLoading(true);

    const response = await doRequest(`/api/SnowflakeDataSources?dataSourceId=${dataSourceId}`, idToken);

    if (!response.isError && response.status !== 204) {
        if (setDataSource) setDataSource(response.data);
        if (setLoading) setLoading(false);
        return response.data;
    } else {
        if (setErrorMessage) setErrorMessage(response.data);
        if (setLoading) setLoading(false);
        return null;
    }
};
